/* Christmas 2026 launch pages: shared runtime (no dependencies, ~12 KB).
   State machine (signup / preview / live) from the hero's date settings, ?state= QA override,
   countdown, date tokens, Klaviyo + Attentive signup, thank-you actions, favorites, quick add, tote counter. */
(function () {
  if (window.EGXmas) return;
  var doc = document, html = doc.documentElement;
  var KEY = 'eg_xmas_2026';
  var $ = function (s, el) { return (el || doc).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || doc).querySelectorAll(s)); };

  /* ---------- persisted visitor state (wrapped in try/catch everywhere) ---------- */
  function load() { try { var s = JSON.parse(localStorage.getItem(KEY) || 'null'); if (s && typeof s === 'object') return s; } catch (e) {} return {}; }
  var store = load(); store.done = store.done || {}; store.favorites = store.favorites || [];
  function save() { try { localStorage.setItem(KEY, JSON.stringify(store)); } catch (e) {} }
  function params() { try { return new URLSearchParams(location.search); } catch (e) { return { get: function () { return null; } }; } }

  /* capture UTMs on first touch (kept until signup) */
  (function () {
    var p = params(), u = {}, any = false;
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) { var v = p.get(k); if (v) { u[k] = String(v).slice(0, 120); any = true; } });
    if (any) { u.captured_at = new Date().toISOString(); u.landing = location.pathname; store.utm = u; save(); }
  })();

  /* ---------- dates + state ---------- */
  var hero = $('[data-eg-xmas-dates]');
  function parse(s) { if (!s) return null; var d = new Date(String(s).trim()); return isNaN(d.getTime()) ? null : d; }
  var dates = {
    preview: parse(hero && hero.getAttribute('data-preview-at')),
    early: parse(hero && hero.getAttribute('data-early-access-at')),
    pub: parse(hero && hero.getAttribute('data-public-at'))
  };
  var override = (function () { var s = params().get('state'); return (s && /^(signup|preview|live)$/.test(s)) ? s : null; })();
  function computeState() {
    if (override) return override;
    if (!dates.early && !dates.preview) return 'live';
    var now = Date.now();
    if (dates.early && now >= dates.early.getTime()) return 'live';
    if (dates.preview && now >= dates.preview.getTime()) return 'preview';
    return 'signup';
  }
  var state = null;
  function applyState() {
    var s = computeState();
    if (s === state) return;
    state = s;
    html.setAttribute('data-eg-xmas-state', s);
    $$('.eg-xmas__state').forEach(function (el) { el.classList.toggle('is-active', el.getAttribute('data-state') === (s === 'live' ? 'live' : 'prelaunch')); });
    try { doc.dispatchEvent(new CustomEvent('eg-xmas:state', { detail: { state: s } })); } catch (e) {}
    if (override) {
      var r = $('#eg-xmas-qa') || doc.createElement('div');
      r.id = 'eg-xmas-qa'; r.className = 'eg-xmas__qa'; r.textContent = 'QA state: ' + s;
      if (!r.parentNode) doc.body.appendChild(r);
    }
  }

  /* ---------- Central-time formatting + copy tokens ---------- */
  function fmt(d, opts) { try { return new Intl.DateTimeFormat('en-US', Object.assign({ timeZone: 'America/Chicago' }, opts)).format(d); } catch (e) { return d.toLocaleString(); } }
  function fDate(d) { return d ? fmt(d, { weekday: 'long', month: 'long', day: 'numeric' }) : ''; }
  function fTime(d) { return d ? fmt(d, { hour: 'numeric', minute: '2-digit' }).replace(/\s?(AM|PM)/, ' $1') + ' CT' : ''; }
  function fShort(d) { return d ? fmt(d, { month: 'numeric', day: 'numeric' }) : ''; }
  var tokens = {
    early_access_date: fDate(dates.early), early_access_time: fTime(dates.early), early_access_short: fShort(dates.early),
    early_access: dates.early ? fDate(dates.early) + ' at ' + fTime(dates.early) : '',
    public_date: fDate(dates.pub), public_time: fTime(dates.pub), public_short: fShort(dates.pub),
    public: dates.pub ? fDate(dates.pub) + ' at ' + fTime(dates.pub) : '',
    preview_date: fDate(dates.preview), preview_short: fShort(dates.preview)
  };
  function replaceTokens(root) {
    $$('[data-eg-tokens]', root).forEach(function (el) {
      var h = el.innerHTML; if (h.indexOf('[') < 0) return;
      el.innerHTML = h.replace(/\[([a-z_]+)\]/g, function (m, k) { return k in tokens ? tokens[k] : m; });
    });
  }

  /* ---------- countdown to early access ---------- */
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function tick() {
    var els = $$('[data-eg-count]'); if (!els.length || !dates.early) return;
    var ms = dates.early.getTime() - Date.now();
    els.forEach(function (el) {
      if (ms <= 0) { el.hidden = true; return; }
      var s = Math.floor(ms / 1000);
      var set = function (k, v) { var n = $('[data-u="' + k + '"]', el); if (n) n.textContent = v; };
      set('d', Math.floor(s / 86400)); set('h', pad(Math.floor(s % 86400 / 3600))); set('m', pad(Math.floor(s % 3600 / 60))); set('s', pad(s % 60));
    });
  }

  /* ---------- analytics ---------- */
  function track(name, payload) {
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, payload || {}); } catch (e) {}
    try { doc.dispatchEvent(new CustomEvent('eg-xmas:' + name, { detail: payload || {} })); } catch (e) {}
  }
  function sha256(str) {
    try { if (window.crypto && crypto.subtle && window.TextEncoder) return crypto.subtle.digest('SHA-256', new TextEncoder().encode(str)).then(function (b) { return Array.prototype.map.call(new Uint8Array(b), function (x) { return ('0' + x.toString(16)).slice(-2); }).join(''); }); } catch (e) {}
    return Promise.resolve('');
  }

  /* ---------- klaviyo (public client endpoints) ---------- */
  function kl(company, path, data) {
    return fetch('https://a.klaviyo.com/client/' + path + '?company_id=' + encodeURIComponent(company), {
      method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2025-04-15' }, body: JSON.stringify({ data: data })
    }).then(function (r) {
      if (r.status === 202 || r.ok) return;
      return r.json().catch(function () { return {}; }).then(function (b) { var d = b && b.errors && b.errors[0] && b.errors[0].detail; throw new Error(d || ('HTTP ' + r.status)); });
    });
  }
  function klEvent(company, name, props) {
    if (!store.email || !company) return Promise.resolve();
    return kl(company, 'events', { type: 'event', attributes: { metric: { data: { type: 'metric', attributes: { name: name } } }, profile: { data: { type: 'profile', attributes: { email: store.email } } }, properties: props || {} } }).catch(function () {});
  }
  function klProfile(company, props) {
    if (!store.email || !company) return Promise.resolve();
    return kl(company, 'profiles', { type: 'profile', attributes: { email: store.email, properties: props } }).catch(function () {});
  }
  function utmProps() {
    var u = store.utm || {}, p = { signup_source: u.utm_source || 'direct' };
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) { if (u[k]) p[k] = u[k]; });
    return p;
  }

  /* ---------- signup card ---------- */
  function err(scope, msg) { var e = $('.eg-xmas__err', scope); if (!e) return; e.textContent = msg || ''; e.classList.toggle('is-shown', !!msg); }
  function busy(btn, on) { if (!btn) return; btn.classList.toggle('is-busy', !!on); btn.disabled = !!on; }
  function e164(v) { var d = (v || '').replace(/\D/g, ''); if (d.length === 11 && d.charAt(0) === '1') d = d.slice(1); if (d.length !== 10 || /^[01]/.test(d) || /^[01]/.test(d.slice(3))) return null; return '+1' + d; }

  function initSignup(root) {
    var cfg = root.dataset, company = cfg.klaviyoCompany, list = cfg.klaviyoList;
    var card = $('.eg-xmas__card', root), stepEmail = $('[data-step="email"]', root), stepSms = $('[data-step="sms"]', root);
    var fEmail = $('form[data-form="email"]', root), fSms = $('form[data-form="sms"]', root);

    function render() {
      var e = !!store.done.email, s = !!store.done.sms, skipped = !!store.skipSms;
      if (stepEmail) stepEmail.classList.toggle('is-done', e);
      // Step 2 (texts) unlocks after the email step. ?sms_preview=1 unlocks it for QA / compliance review.
      var smsPreview = /[?&]sms_preview=1/.test(location.search);
      if (stepSms) { stepSms.classList.toggle('is-locked', !e && !smsPreview); stepSms.classList.toggle('is-done', s); stepSms.classList.toggle('is-skipped', !s && skipped); }
      var done = e && (s || skipped || !stepSms);
      if (card) card.classList.toggle('is-done', done);
      $$('[data-first]', root).forEach(function (n) { n.textContent = store.first || 'friend'; });
      $$('[data-sms-note]', root).forEach(function (n) { n.hidden = !s; });
    }

    if (fEmail) fEmail.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var hp = $('input[name="website"]', fEmail); if (hp && hp.value) return;
      var first = ($('input[name="first"]', fEmail) || {}).value || '', email = ($('input[name="email"]', fEmail).value || '').trim().toLowerCase();
      first = first.trim().slice(0, 60);
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) return err(stepEmail, 'That email does not look right. Check it and try again.');
      if (!company || !list) return err(stepEmail, 'Signup is not configured yet (Klaviyo list missing in the section settings).');
      err(stepEmail, '');
      var btn = $('button[type="submit"]', fEmail); busy(btn, true);
      var now = new Date().toISOString();
      var props = Object.assign({ christmas_2026_early_access: true, signup_page: cfg.signupPage || 'christmas-2026', christmas_2026_signed_up_at: now }, utmProps());
      var prof = { email: email, properties: props, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } };
      if (first) prof.first_name = first;
      kl(company, 'subscriptions', { type: 'subscription', attributes: { custom_source: cfg.customSource || 'Christmas 2026 early access page', profile: { data: { type: 'profile', attributes: prof } } }, relationships: { list: { data: { type: 'list', id: list } } } })
        .then(function () {
          store.email = email; store.first = first; store.done.email = true; store.signedUpAt = now; save(); render();
          klEvent(company, 'Christmas Early Access Signup', Object.assign({ page: location.href.split('?')[0] }, utmProps()));
          sha256(email).then(function (h) { track('christmas_early_access_signup', Object.assign({ email_hash: h, page: cfg.signupPage || 'christmas-2026', first_name: first ? true : false }, utmProps())); });
          var sms = $('input[name="phone"]', root); if (sms) { try { sms.focus({ preventScroll: true }); } catch (e) {} }
        })
        .catch(function (e) { err(stepEmail, 'Something went wrong. Please try again in a moment.'); if (window.console) console.warn('eg-xmas signup', e); })
        .then(function () { busy(btn, false); });
    });

    if (fSms) fSms.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var phone = e164($('input[name="phone"]', fSms).value);
      if (!phone) return err(stepSms, 'Please enter a 10-digit US mobile number.');
      if (!cfg.smsRelay) return err(stepSms, 'Texts are not set up yet. You can skip this step.');
      err(stepSms, '');
      var btn = $('button[type="submit"]', fSms); busy(btn, true);
      var headers = { 'Content-Type': 'application/json' };
      if (cfg.smsRelayKey) { headers.apikey = cfg.smsRelayKey; headers.Authorization = 'Bearer ' + cfg.smsRelayKey; }
      fetch(cfg.smsRelay, { method: 'POST', headers: headers, body: JSON.stringify({ email: store.email || '', first: store.first || '', phone: phone, source: cfg.signupPage || 'christmas-2026', attribute: cfg.attentiveAttribute || '', value: cfg.attentiveValue || '' }) })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (b) { if (!r.ok || !b.ok) throw new Error(b.error || ('HTTP ' + r.status)); }); })
        .then(function () {
          store.done.sms = true; store.phone = phone; save(); render();
          klProfile(company, { christmas_2026_sms: true, christmas_2026_phone: phone, christmas_2026_sms_at: new Date().toISOString(), christmas_2026_sms_provider: 'attentive', christmas_2026_sms_page: cfg.signupPage || 'christmas-2026' });
          track('christmas_early_access_sms', { page: 'christmas-2026' });
        })
        .catch(function (e) { var notOpen = /SIGNUP_SOURCE_ID|not set/i.test(String(e && e.message)); err(stepSms, notOpen ? 'Texts open in a few days. You are on the email list, so skip this step for now and add texts later from the thank-you screen.' : 'We could not sign that number up right now. Check it and try again, or skip this step.'); if (window.console) console.warn('eg-xmas sms', e); })
        .then(function () { busy(btn, false); });
    });

    $$('[data-skip-sms]', root).forEach(function (b) { b.addEventListener('click', function () { store.skipSms = true; save(); render(); }); });
    $$('[data-add-sms]', root).forEach(function (b) { b.addEventListener('click', function () { store.skipSms = false; save(); render(); var i = $('input[name="phone"]', root); if (i) i.focus(); }); });
    $$('[data-reset]', root).forEach(function (b) { b.addEventListener('click', function (ev) { ev.preventDefault(); var fav = store.favorites, utm = store.utm; store = { done: {}, favorites: fav, utm: utm }; save(); render(); }); });

    /* thank-you actions */
    var calBtn = $('[data-calendar]', root);
    if (calBtn) calBtn.addEventListener('click', function () {
      if (!dates.early) return;
      var start = dates.early, end = new Date(start.getTime() + 60 * 60000);
      var ics = function (d) { return d.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, ''); };
      var esc = function (s) { return String(s || '').replace(/\\/g, '\\\\').replace(/\n/g, '\\n').replace(/,/g, '\\,').replace(/;/g, '\\;'); };
      var title = cfg.calTitle || 'Elly and Grace Christmas early access', desc = (cfg.calText || '') + (cfg.pageUrl ? ' ' + cfg.pageUrl : '');
      var body = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Elly and Grace//Christmas 2026//EN', 'CALSCALE:GREGORIAN', 'METHOD:PUBLISH', 'BEGIN:VEVENT',
        'UID:christmas-2026-early-access@ellyandgrace.com', 'DTSTAMP:' + ics(new Date()), 'DTSTART:' + ics(start), 'DTEND:' + ics(end),
        'SUMMARY:' + esc(title), 'DESCRIPTION:' + esc(desc), 'URL:' + (cfg.pageUrl || location.href.split('?')[0]),
        'BEGIN:VALARM', 'TRIGGER:-PT15M', 'ACTION:DISPLAY', 'DESCRIPTION:' + esc(title), 'END:VALARM', 'END:VEVENT', 'END:VCALENDAR'].join('\r\n');
      try {
        var blob = new Blob([body], { type: 'text/calendar;charset=utf-8' }), url = URL.createObjectURL(blob), a = doc.createElement('a');
        a.href = url; a.download = 'elly-and-grace-christmas-early-access.ics'; doc.body.appendChild(a); a.click(); doc.body.removeChild(a);
        setTimeout(function () { URL.revokeObjectURL(url); }, 4000);
      } catch (e) { window.open('data:text/calendar;charset=utf-8,' + encodeURIComponent(body)); }
      track('christmas_early_access_calendar', {});
    });
    var gcal = $('[data-gcal]', root);
    if (gcal && dates.early) {
      var g = function (d) { return d.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, ''); };
      gcal.href = 'https://calendar.google.com/calendar/render?action=TEMPLATE&text=' + encodeURIComponent(cfg.calTitle || 'Elly and Grace Christmas early access') + '&dates=' + g(dates.early) + '/' + g(new Date(dates.early.getTime() + 3600000)) + '&details=' + encodeURIComponent((cfg.calText || '') + ' ' + (cfg.pageUrl || '')) + '&location=' + encodeURIComponent(cfg.pageUrl || '');
    }
    var shareBtn = $('[data-share]', root);
    if (shareBtn) shareBtn.addEventListener('click', function () {
      var url = (cfg.pageUrl || location.href.split('?')[0]) + '?utm_source=share&utm_medium=friend&utm_campaign=christmas-2026';
      var text = cfg.shareText || 'Get early access to the Elly and Grace Christmas collection:';
      var done = function (label) { var s = $('span', shareBtn); if (s) { var was = s.textContent; s.textContent = label; setTimeout(function () { s.textContent = was; }, 2200); } };
      if (navigator.share) { navigator.share({ title: cfg.shareTitle || 'Elly and Grace Christmas 2026', text: text, url: url }).then(function () { track('christmas_early_access_share', { method: 'native' }); }).catch(function () {}); }
      else if (navigator.clipboard) { navigator.clipboard.writeText(text + ' ' + url).then(function () { done('Link copied!'); track('christmas_early_access_share', { method: 'copy' }); }, function () { window.prompt('Copy this link', url); }); }
      else { window.prompt('Copy this link', url); }
    });
    /* PushOwl: show the button only when the SDK is present and permission is still undecided */
    var push = $('[data-push]', root);
    if (push) {
      var tries = 0, poll = setInterval(function () {
        tries++;
        var po = window.pushowl;
        if (po) {
          clearInterval(poll);
          var perm = (window.Notification && Notification.permission) || 'default';
          if (perm === 'default' && window.Notification) { push.hidden = false; }
          push.addEventListener('click', function () {
            try { if (typeof po.trigger === 'function') po.trigger('showWidget', { type: 'browserPrompt' }); else if (typeof po.showWidget === 'function') po.showWidget({ type: 'browserPrompt' }); } catch (e) {}
            track('christmas_early_access_push', {});
            setTimeout(function () { if (window.Notification && Notification.permission !== 'default') push.hidden = true; }, 3000);
          });
        } else if (tries > 20) clearInterval(poll);
      }, 500);
    }
    render();
  }

  /* ---------- favorites ---------- */
  function initFavorites(company) {
    $$('[data-eg-fav]').forEach(function (b) {
      var h = b.getAttribute('data-handle');
      var on = store.favorites.indexOf(h) >= 0;
      b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (b.dataset.bound) return; b.dataset.bound = '1';
      b.addEventListener('click', function () {
        var i = store.favorites.indexOf(h), now = i < 0;
        if (now) store.favorites.push(h); else store.favorites.splice(i, 1);
        save();
        b.classList.toggle('is-on', now); b.setAttribute('aria-pressed', now ? 'true' : 'false');
        var props = { handle: h, title: b.getAttribute('data-title'), image: b.getAttribute('data-image'), url: location.origin + b.getAttribute('data-url'), price: b.getAttribute('data-price'), favorites_total: store.favorites.length };
        if (now) klEvent(company, 'Favorited Christmas Product', props); else klEvent(company, 'Unfavorited Christmas Product', props);
        track(now ? 'christmas_product_favorited' : 'christmas_product_unfavorited', { handle: h });
      });
    });
  }

  /* ---------- quick add (single-variant products) into Impulse's cart drawer ---------- */
  function cartAddUrl() { return (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js'; }
  function hasDrawer() { return !!(window.theme && theme.settings && theme.settings.cartType === 'drawer' && doc.getElementById('CartDrawer')); }
  function initQuickAdd() {
    $$('form[data-eg-add]').forEach(function (form) {
      if (form.dataset.bound) return; form.dataset.bound = '1';
      form.addEventListener('submit', function (ev) {
        if (!hasDrawer()) return; /* plain POST to /cart */
        ev.preventDefault();
        var btn = $('button[type="submit"]', form), span = $('span', btn) || btn, was = span.textContent, e = $('.eg-xmas__card-err', form);
        busy(btn, true); span.textContent = 'Adding...'; if (e) e.classList.remove('is-shown');
        fetch(cartAddUrl(), { method: 'POST', body: new FormData(form), credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
          .then(function (res) {
            if (!res.ok || res.data.status) throw new Error(res.data.description || res.data.message || 'Could not add to cart');
            span.textContent = 'Added'; setTimeout(function () { span.textContent = was; }, 2200);
            form.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: res.data, addToCartBtn: btn }, bubbles: true }));
          })
          .catch(function (x) { if (e) { e.textContent = x.message || 'Could not add to cart'; e.classList.add('is-shown'); } span.textContent = was; })
          .then(function () { busy(btn, false); });
      });
    });
  }

  /* ---------- tote counter (live, via the Section Rendering API) ---------- */
  var tote = { left: null, total: null };
  function paintTote(data) {
    tote = data;
    $$('[data-eg-tote]').forEach(function (el) {
      var left = Math.max(0, data.left | 0), total = data.total | 0, gone = left <= 0;
      $$('[data-eg-tote-left]', el).forEach(function (n) { n.textContent = left; });
      $$('[data-eg-tote-total]', el).forEach(function (n) { n.textContent = total; });
      $$('[data-eg-tote-bar]', el).forEach(function (n) { n.style.width = (total ? Math.round(left / total * 100) : 0) + '%'; });
      $$('[data-eg-tote-live]', el).forEach(function (n) { n.hidden = gone; });
      $$('[data-eg-tote-gone]', el).forEach(function (n) { n.hidden = !gone; });
    });
    try { doc.dispatchEvent(new CustomEvent('eg-xmas:tote', { detail: data })); } catch (e) {}
  }
  function refreshTote() {
    if (!$$('[data-eg-tote]').length) return;
    fetch('/?section_id=eg-xmas-tote-count', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (t) {
      var m = /<script[^>]*data-eg-tote-json[^>]*>([\s\S]*?)<\/script>/.exec(t); if (!m) return;
      try { var d = JSON.parse(m[1]); if (d && d.ok) paintTote(d); } catch (e) {}
    }).catch(function () {});
  }

  /* ---------- sticky countdown bar (phones, before launch, not yet signed up) ---------- */
  function initSticky() {
    var bar = $('[data-eg-sticky]'); if (!bar) return;
    var hero = $('#eg-xmas-hero');
    function update() {
      var past = hero ? (window.scrollY > hero.offsetTop + hero.offsetHeight - 80) : window.scrollY > 600;
      var form = $('#eg-xmas-signup'), nearForm = false;
      if (form) { var r = form.getBoundingClientRect(); nearForm = r.top < window.innerHeight && r.bottom > 0; }
      var show = past && !nearForm && state !== 'live' && !store.done.email && window.innerWidth < 861;
      bar.hidden = !show; doc.body.classList.toggle('eg-xmas-has-sticky', show);
    }
    window.addEventListener('scroll', update, { passive: true }); window.addEventListener('resize', update);
    doc.addEventListener('eg-xmas:state', update); update();
    $$('form[data-form="email"]').forEach(function (f) { f.addEventListener('submit', function () { setTimeout(update, 1500); }); });
  }

  /* ---------- sneak peek arrows ---------- */
  function initPeek() {
    $$('[data-eg-peek]').forEach(function (strip) {
      var sec = strip.closest('section'); if (!sec || sec.dataset.peekInit) return; sec.dataset.peekInit = '1';
      var step = function () { var item = strip.querySelector('.eg-xmas__peek-item'); return item ? (item.getBoundingClientRect().width + 12) * 2 : strip.clientWidth * .8; };
      var prev = $('[data-eg-peek-prev]', sec), next = $('[data-eg-peek-next]', sec);
      if (prev) prev.addEventListener('click', function () { strip.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { strip.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  }

  /* ---------- hero slider: crossfade, dots, swipe, pause on hover ---------- */
  function initSliders() {
    $$('[data-eg-slider]').forEach(function (el) {
      if (el.dataset.init) return; el.dataset.init = '1';
      var slides = $$('.eg-xmas__slide', el), dots = $$('.eg-xmas__dots button', el), i = 0, timer, ms = +el.dataset.interval || 4000, paused = false;
      if (slides.length < 2) return;
      function go(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }
      function start() { stop(); if (!paused && !(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) timer = setInterval(function () { go(i + 1); }, ms); }
      function stop() { clearInterval(timer); }
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); start(); }); });
      el.addEventListener('mouseenter', function () { paused = true; stop(); });
      el.addEventListener('mouseleave', function () { paused = false; start(); });
      var x0 = null;
      el.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
      el.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1); start(); }, { passive: true });
      doc.addEventListener('visibilitychange', function () { doc.hidden ? stop() : start(); });
      start();
    });
  }

  /* ---------- boot ---------- */
  function boot() {
    applyState(); replaceTokens(doc); tick();
    var company = (hero && hero.getAttribute('data-klaviyo-company')) || ($('[data-eg-signup]') && $('[data-eg-signup]').dataset.klaviyoCompany) || '';
    $$('[data-eg-signup]').forEach(initSignup);
    initFavorites(company); initQuickAdd();
    var boot0 = $('[data-eg-tote]'); if (boot0 && boot0.dataset.left !== undefined) paintTote({ ok: true, left: +boot0.dataset.left, total: +boot0.dataset.total });
    initSticky(); initPeek(); initSliders();
    setTimeout(refreshTote, 1500); setInterval(refreshTote, 60000);
    setInterval(tick, 1000); setInterval(applyState, 30000);
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot); else boot();
  /* theme editor: re-init when a section is re-rendered */
  doc.addEventListener('shopify:section:load', function () { initSliders(); applyState(); replaceTokens(doc); $$('[data-eg-signup]').forEach(function (r) { if (!r.dataset.init) { r.dataset.init = '1'; initSignup(r); } }); initFavorites(''); initQuickAdd(); });

  window.EGXmas = { get state() { return state; }, dates: dates, tokens: tokens, store: function () { return store; }, save: save, track: track, refreshTote: refreshTote, tote: function () { return tote; } };
})();
